export default {
  module: {
    key: 'bbs/osa-theme',
    id: 'bbs-osa-theme',
  },
};
